import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { useState } from 'react';
import { RadioButton } from './RadioButton';
import { useNavigate } from 'react-router-dom';
import { ListClientsModal } from './ListClientsModal';
import { useDisclosure } from '@mantine/hooks';

interface NewFormModalProps {
  opened: boolean;
  close: () => void;
}

export const NewFormModal: React.FC<NewFormModalProps> = props => {
  const navigate = useNavigate();
  const [newApplicant, setNewApplicant] = useState('new');

  const [
    openedListClinetsModal,
    { open: openListClinetsModal, close: closeListClinetsModal },
  ] = useDisclosure(false);

  const handleNewApplicant = () => {
    navigate('/applicants/new-empty-form');
  };

  const handleExistingApplicant = () => {
    openListClinetsModal();
  };

  return (
    <Modal
      opened={props.opened}
      onClose={props.close}
      title="Nový formulář"
      centered
      radius="md"
    >
      <Stack>
        <Stack style={{ margin: '10px' }}>
          <Group justify="space-between">
            <Text>Nový klient</Text>
            <RadioButton
              selected={newApplicant === 'new'}
              onClick={() => setNewApplicant('new')}
            />
          </Group>

          <Group justify="space-between">
            <Text>Existující klient</Text>
            <RadioButton
              selected={newApplicant === 'exist'}
              onClick={() => setNewApplicant('exist')}
            />
          </Group>
        </Stack>

        <Group grow>
          <Button variant="outline" onClick={props.close}>
            Zrušit
          </Button>

          <Button
            onClick={() => {
              if (newApplicant === 'new') {
                handleNewApplicant();
              } else {
                handleExistingApplicant();
              }
            }}
          >
            Pokračovat
          </Button>
        </Group>
      </Stack>
      <ListClientsModal
        opened={openedListClinetsModal}
        close={closeListClinetsModal}
        parrentClose={props.close}
      />
    </Modal>
  );
};
